export const arr = [
  {
    id: 0,
    img: 'https://ichef.bbci.co.uk/news/976/cpsprodpb/1F36/production/_118109970_livreal.jpg',
    content: 'lorem ipsum dolor sit amet',
  },
  {
    id: 1,
    img: 'https://www.worcester.gov.uk/images/easyblog_shared/2019/b2ap3_large_Football---carousel.jpg',
    content: 'lorem ipsum dolor sit amet',
  },
  {
    id: 2,
    img: 'https://i.ytimg.com/vi/GvxlcBJCrTs/maxresdefault.jpg',
    content: 'lorem ipsum dolor sit amet',
  },
  {
    id: 3,
    img: 'https://o7dkx1gd2bwwexip1qwjpplu-wpengine.netdna-ssl.com/wp-content/uploads/2019/06/Screen-Shot-2019-06-19-at-12.50.57-PM.png',
    content: 'lorem ipsum dolor sit amet',
  },
];
